import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../../elements";
import { Col, Pagination } from "react-bootstrap";

export default function IssuerProductsTableComponent({ thead, tbody, activeTab }) {
    const { t } = useContext(TranslatorContext);

    const [alertModal, setAlertModal] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [data, setData] = useState([]);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    useEffect(() => {
        setData(tbody || []);
        setCurrentPage(1);
    }, [tbody, activeTab]);

    const handleDeleteClick = (id) => {
        setSelectedProductId(id);
        setAlertModal(true);
    };

    // Calculate current products to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    // Handle page change
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Helper function to render pagination items with ellipsis logic
    const renderPaginationItems = () => {
        const items = [];
        const maxPagesToShow = 5;

        if (totalPages <= maxPagesToShow + 2) {
            for (let number = 1; number <= totalPages; number++) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => handlePageChange(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }
        } else {
            items.push(
                <Pagination.Item
                    key={1}
                    active={1 === currentPage}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </Pagination.Item>
            );

            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);

            if (currentPage <= 3) {
                endPage = 4;
            } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 3;
            }

            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
            }

            for (let number = startPage; number <= endPage; number++) {
                items.push(
                    <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => handlePageChange(number)}
                    >
                        {number}
                    </Pagination.Item>
                );
            }

            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
            }

            items.push(
                <Pagination.Item
                    key={totalPages}
                    active={totalPages === currentPage}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {/* 1st column width increased */}
                        <th style={{ width: "22%" }}>{t(thead?.[0])}</th>
                        {/* 2nd column width increased */}
                        <th style={{ width: "20%" }}>{t(thead?.[1])}</th>
                        {/* 3rd column width increased */}
                        <th style={{ width: "33%" }}>{t(thead?.[2])}</th>
                        <th style={{ width: "15%" }}>{t(thead?.[3])}</th>
                        {/* Action column width decreased */}
                        <th style={{ width: "10%", textAlign: "center" }}>{t(thead?.[4])}</th>
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {currentData && currentData.length > 0 ? (
                        currentData.map((item, index) => {
                            const pImage = item?.first_img ? `${process.env.REACT_APP_IMG_URL}${item.first_img}` : "";
                            const pTitle = item?.title || "N/A";
                            const pDescribe = item?.selling_style || "N/A";
                            const pCode = item?.product_code || "N/A";
                            const style = item?.selling_style || "N/A";

                            const pricePrev = typeof item?.price === "object" ? item?.price?.previous : null;
                            const pricePresent = item?.sell_price_dollar;

                            const isStudy =
                                pricePresent === null ||
                                pricePresent === undefined ||
                                pricePresent === "" ||
                                pricePresent === 0 ||
                                pricePresent === "0";

                            const iconView = "visibility";
                            const iconEdit = "edit";

                            return (
                                <tr key={item?.id || index}>
                                    {/* 1st Column */}
                                    <td style={{ verticalAlign: "top", width: "22%" }}>
                                        <div
                                            className="d-flex flex-column gap-2"
                                            style={{
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {/* Movement Type show karna */}
                                            {item.latest_timeline?.movement_type && (
                                                <div>
                                                    <span className="badge bg-info text-dark mb-1">
                                                        {item.latest_timeline?.movement_type}
                                                    </span>
                                                </div>
                                            )}

                                            {item.issue_date && (
                                                <div>
                                                    <strong style={{ fontSize: "12px" }}>Issue Date:</strong>
                                                    <div style={{ fontSize: "13px" }}>{item.issue_date}</div>
                                                </div>
                                            )}

                                            {(item.latest_timeline?.title || item.status) && (
                                                <div>
                                                    <strong style={{ fontSize: "12px" }}>Status:</strong>
                                                    <div style={{ fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" }}>
                                                        {item.latest_timeline?.title || item.status}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </td>

                                    {/* 2nd Column */}
                                    <td style={{ verticalAlign: "top", width: "20%" }}>
                                        <div className="mc-table-check d-flex flex-column align-items-start gap-1">
                                            <span style={{ wordBreak: "break-all" }}>{pCode}</span>

                                            {item.rejection_reason && (
                                                <span
                                                    className="badge bg-danger-subtle text-danger text-wrap text-start mt-1"
                                                    style={{ fontSize: "11px", maxWidth: "160px", lineHeight: "1.2" }}
                                                >
                                                    <strong>{t("rejection reason")}:</strong> {item.rejection_reason}
                                                </span>
                                            )}
                                        </div>
                                    </td>

                                    {/* 3rd Column */}
                                    <td style={{ verticalAlign: "top", width: "33%" }}>
                                        <div className="mc-table-product md">
                                            {pImage && <img src={pImage} alt={pTitle} />}
                                            <div className="mc-table-group">
                                                <h6>{pTitle}</h6>
                                                <p>{pDescribe}</p>
                                            </div>
                                        </div>
                                    </td>

                                    {/* Selling Price Column */}
                                    <td style={{ verticalAlign: "top", width: "15%" }}>
                                        <div className="mc-table-price">
                                            {style && (
                                                <>
                                                    <span>{style}</span>
                                                    <br />
                                                </>
                                            )}

                                            {pricePrev && <del>{pricePrev}</del>}

                                            {isStudy ? (
                                                <span className="badge bg-warning text-dark fw-bold">
                                                    Study
                                                </span>
                                            ) : (
                                                <p>${pricePresent}</p>
                                            )}
                                        </div>
                                    </td>

                                    {/* Action Column - Width kam ki gayi hai */}
                                    <td style={{ verticalAlign: "top", width: "10%", textAlign: "center" }}>
                                        <div className="mc-table-action justify-content-center">
                                            <AnchorComponent
                                                to={`/issuer/issued-products/${item?.id || ''}`}
                                                state={{ product: item, activeTab }}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                {iconView}
                                            </AnchorComponent>

                                            {(activeTab === "new" || activeTab === "rejected") && (
                                                <AnchorComponent
                                                    to={'/issue-product-edit'}
                                                    state={{ item, activeTab }}
                                                    title="Edit"
                                                    className="material-icons edit"
                                                >
                                                    {iconEdit}
                                                </AnchorComponent>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={thead?.length || 5} className="text-center py-4">
                                {t("no_products_found")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="d-flex justify-content-end mt-4 px-3">
                    <Pagination>
                        <Pagination.First
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}
                        />
                        <Pagination.Prev
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        />

                        {renderPaginationItems()}

                        <Pagination.Next
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                        <Pagination.Last
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </div>
            )}

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_product")}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setAlertModal(false)}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={() => setAlertModal(false)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}